export function isIterable(value) {
  // checks for null and undefined
  if (value == null) {
    return false;
  }
  return typeof value[Symbol.iterator] === "function";
}

export function wrapInArray(value) {
  if (value == null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (isIterable(value)) {
    return [...value];
  }
  return [value];
}

export function deepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a instanceof Date && b instanceof Date) {
    // If the values are Date, they were convert to timestamp with getTime and compare it
    if (a.getTime() !== b.getTime()) return false;
  }

  if (a !== Object(a) || b !== Object(b)) {
    // If the values aren't objects, they were already checked for equality
    return false;
  }

  const props = Object.keys(a);

  if (props.length !== Object.keys(b).length) {
    // Different number of props, don't bother to check
    return false;
  }
  return props.every((p) => deepEqual(a[p], b[p]));
}

export function truncate(text, length, omission = "right", pad = "...") {
  if (text.length <= length) {
    return text;
  }
  if (omission === "right") {
    return text.substr(0, length) + pad;
  }
  if (omission === "left") {
    return pad + text.substr(text.length - length, length);
  }

  if (omission === "middle") {
    return text.substr(0, length / 2) + pad + text.substr(-length / 2);
  }
}
